import { useEffect } from 'react';
import CardProduct from '../../card/CardProduct/CardProduct';
import LeftMenuDesign from '../../common/LeftMenuDesign/LeftMenuDesign';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInsideAccessories } from '../../../store/actions/insideAccessory.action';
import { useTranslation } from 'react-i18next';
import { getValueFromString } from '../../../utils/data/getValue.utils';

const LeftInsideDesignMenu = ({ open, onDragStart, title, productType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { insideAccessories } = useSelector(state => state.insideAccessory);
  // const { products } = useSelector(state => state.product);

  // Fetch khi product_type đổi (lần đầu + mọi lần đổi)
  useEffect(() => {
    if (!productType) return;
    dispatch(fetchInsideAccessories(productType));
  }, [dispatch, productType]);

  // Nếu nơi khác set cờ reload, fetch lại với productType hiện tại
  useEffect(() => {
    if (!productType) return;
    if (insideAccessories?.isNeedReloadData) {
      dispatch(fetchInsideAccessories(productType));
    }
  }, [dispatch, productType, insideAccessories?.isNeedReloadData]);

  const insides = insideAccessories?.data?.insides ?? [];
  // const accessories = insideAccessories?.data?.accessories ?? [];

  return (
    <LeftMenuDesign
      open={open}
      classNames={{ root: '!left-[72px] relative', content: '!p-0 gap-0' }}
      header={<span className="text-title-large text-nowrap">{title}</span>}
      content={
        <>
          {/* <div className="flex py-8 px-16 bg-fills-white">
            <ListTypeModule />
          </div>
          <Divider type="horizontal" style={{ margin: 0 }} /> */}
          <div className="grid grid-cols-2 p-8 items-start align-content-start gap-2 self-stretch">
            {insides?.map((md, i) => {
              const name = getValueFromString(md.name);
              const description = getValueFromString(md.description ?? '');

              return (
                <CardProduct
                  key={i}
                  md={md}
                  title={name}
                  description1={description}
                  description2={md.size}
                  moduleType={i}
                  onDragStart={onDragStart}
                />
              );
            })}
          </div>
        </>
      }
    />
  );
};

export default LeftInsideDesignMenu;
